export const COLOR_TO_SEND = 'secondary';
export const COLOR_PUBLISHED = 'warning';
export const COLOR_SENT = 'accent';
export const COLOR_BILLED = 'success';
export const COLOR_ERROR = 'error';